import { Icon, type IconName } from './icon';

const KIND_ICON_MAP: Record<string, IconName> = {
  agent: 'bot',
  hive: 'git-branch',
  collection: 'folder-open',
  skill: 'sparkles',
};

interface KindIconProps {
  kind: string;
  size?: number;
  className?: string;
}

export function KindIcon({ kind, size = 20, className }: KindIconProps) {
  const name = KIND_ICON_MAP[kind] ?? 'file';
  return <Icon name={name} size={size} className={className} />;
}
